import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUsecaseModules, getUsecaseUserTypes } from "../../Api/WebsiteServices/websiteService";
import { mapModules, mapUserTypes } from "../../../Website/Types/Common/FeaturesBreakdown";

// fetch use case user types
export const fetchUseCaseUserTypes = createAsyncThunk(
    'fetchUseCaseUserTypes',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getUsecaseUserTypes();
            if (response.status) {
                return mapUserTypes(response.body);
            } else {
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            return rejectWithValue('Failed to fetch use case user types data');
        }
    }
);

// fetch use case modules
export const fetchUseCaseModules = createAsyncThunk(
    'fetchUseCaseModules',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getUsecaseModules();
            if (response.status) {
                return mapModules(response.body);
            } else {
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            return rejectWithValue('Failed to fetch use case modules data');
        }
    }
);